// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Returns24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Returns24Circle: FC<Returns24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="33"
        >
            <path
                d="M16 32.076c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Zm-5-11.5v2h7.1c1.617 0 3.004-.525 4.162-1.575C23.421 19.951 24 18.643 24 17.076c0-1.567-.58-2.875-1.738-3.925-1.158-1.05-2.545-1.575-4.162-1.575h-6.3l2.6-2.6-1.4-1.4-5 5 5 5 1.4-1.4-2.6-2.6h6.3c1.05 0 1.962.333 2.737 1 .776.667 1.163 1.5 1.163 2.5s-.387 1.833-1.163 2.5c-.774.667-1.687 1-2.737 1H11Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Returns24Circle;
